// Action Types
const SET_NOTIFICATION = 'SET_NOTIFICATION' as const;
const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION' as const;

// Action Interfaces
interface SetNotificationAction {
  type: typeof SET_NOTIFICATION;
  payload: {
    type: 'success' | 'error' | null;
    message: React.ReactNode;
  };
}

interface ClearNotificationAction {
  type: typeof CLEAR_NOTIFICATION;
}

type NotificationActions = SetNotificationAction | ClearNotificationAction;

// Action Creators
export const setNotification = (payload: { type: 'success' | 'error' | null; message: React.ReactNode }) => ({
  type: SET_NOTIFICATION,
  payload,
});

export const clearNotification = (): ClearNotificationAction => ({
  type: CLEAR_NOTIFICATION,
});

// State Type
interface NotificationState {
  type: 'success' | 'error' | null;
  message: React.ReactNode | null;
}

// Initial State
const initialState: NotificationState = {
  type: null,
  message: null,
};

// Reducer
const notificationReducer = (
  state: NotificationState = initialState,
  action: NotificationActions
): NotificationState => {
  switch (action.type) {
    case SET_NOTIFICATION:
      return { ...state, ...action.payload }; // Set type and message
    case CLEAR_NOTIFICATION:
      return { ...state, type: null, message: null }; // Reset both fields
    default:
      return state;
  }
};

export default notificationReducer;
